import Playlist from './playlist';
import 'slick-carousel/slick/slick.scss';
import 'slick-carousel/slick/slick-theme.scss';
import './styles.scss';
export default Playlist;


// WEBPACK FOOTER //
// ./medscape_modules/video/playlist/index.js